import { memo } from "react";

import Box from "ds/components/Box";
import ListEntitiesItemDescriptionMultipleLines from "components/ListEntitiesItem/Description/MultipleLines";
import { ManagedUserGroup } from "types/generated";

type IdpGroupDescriptionCellProps = {
  group: ManagedUserGroup;
};

const IdpGroupDescriptionCell = ({ group }: IdpGroupDescriptionCellProps) => {
  if (!group.description) {
    return null;
  }

  return (
    <Box direction="row" align="start">
      <ListEntitiesItemDescriptionMultipleLines
        lines={1}
        hasChevronLink
        description={group.description}
      />
    </Box>
  );
};

export default memo(IdpGroupDescriptionCell);
